<template>
  <section class="layoutLayout advanced weflix-admin-advancedLayout">
    <TitlePage title="Personalização Avançada" subtitle="Personalize seu site com códigos JavaScript e CSS" :hasMargin="true" />  
      <div class="col-form-inner col-12 col-md-12 col-lg-12 flex" v-if="hasReady">
        <!-- JavaScript -->
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
          <div class="form-group">
            <div class="form-label">
              <label>JavaScript Personalizado:</label>
            </div>
            <div class="form-input">
              <textarea
                class="form-control code-editor"
                placeholder="console.log('JavaScript Personalizado');"
                v-model="javascript"
                rows="5"
              ></textarea>
              <small class="small">
                Adicione código JavaScript personalizado que será executado no header da página do seu site.
                <br/>
                <span class="text-danger js-warning">ATENÇÃO: Adicionar códigos JavaScript incorretos pode afetar o funcionamento do seu site.</span>
              </small>
            </div>
          </div>
        </div>

        <!-- CSS -->
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
          <div class="form-group">
            <div class="form-label">
              <label>CSS Personalizado:</label>
            </div>
            <div class="form-input">
              <textarea
                class="form-control code-editor"
                placeholder="body { background-color: #f0f0f0; }"
                v-model="css"
                rows="5"
              ></textarea>
              <small class="small">
                Adicione estilos CSS personalizados para customizar a aparência do seu site. Estes estilos serão aplicados em todas as páginas do seu site.
                <br/>
                <span class="text-danger css-warning">ATENÇÃO: Adicionar códigos CSS incorretos pode afetar o layout do seu site.</span>
              </small>
            </div>
          </div>
        </div>

    </div>
    <div class="weflix-admin-advancedLayoutBtn" v-if="hasReady">
      <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="updateAdvanced">Salvar</v-btn>
    </div>
  </section>
  <Loader :hasReady="hasReady"/>
</template>

<script>
import websiteApi from '@/utils/Weflix/website';
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
  data(){
      return{
          javascript: '',
          css: '',
          id: '',
          name: '',
          description: '',
          logo: '',
          favicon: '',
          logoPreview: '',
          faviconPreview: '',
          url: '',
          status: '',
          hasReady: false,
          activeTheme: '',
          color: '',
          facebook: '',
          gads: '',
          ganalytic: '',
          tagManager: '',
          rdrefreshToken: '',
          rdcode: '',
          rdSecret: '',
          rdClient: '',
          descriptionAbout: ''
      }
  },
  components: {
      Loader,
      TitlePage
  },
  computed: {
    ...mapState(['token', 'layoutWebsite']),
    finalWebsite() {
      // Tenta pegar o finalWebsite do vuex, se não existir, pega layoutWebsite
      if (this.$store.state.finalWebsite) {
        return this.$store.state.finalWebsite;
      }
      if (this.layoutWebsite) {
        return this.layoutWebsite;
      }
      return {};
    }
  },
  methods:{
    ...mapActions(['storeLayoutWebsite']),
    // Função para sobrescrever campos do response com os do finalWebsite
    mergeWithFinalWebsite(response) {
      const fw = this.finalWebsite || {};
      // Lista de campos a serem sobrescritos
      const campos = [
        'nome', 'url', 'url1', 'url2', 'title', 'description', 'keywords', 'logo', 'color', 'favicon', 'logoFinal', 'faviconFinal',
        'status', 'tagManagerCode', 'typeLayout', 'javascript', 'css', 'typeLayoutPortal', 'googleAnalyticsCode', 'facebookPixelCode',
        'dateInsert', 'email', 'phone', 'numberCollection', 'numberVideo', 'timeVideo', 'numberSubscription', 'about', 'termUse',
        'typeImageCoverCourse', 'visibleTitleCourse', 'googleAdsCode', 'rdsecretClient', 'rdclienteId', 'rdcode', 'rdrefreshToken'
      ];
      let merged = { ...response };
      campos.forEach(campo => {
        if (fw[campo] !== undefined && fw[campo] !== null) {
          merged[campo] = fw[campo];
        }
      });
      return merged;
    },
    async getAdvanced() {
      const response = await websiteApi.getWebsite(this.token);
      // Sobrescreve os campos do response com os do finalWebsite, se existirem
      const merged = this.mergeWithFinalWebsite(response);

      this.id = merged.id;
      this.name = merged.nome;
      this.description = merged.description;
      this.logo = merged.logo;
      this.favicon = merged.favicon;
      this.logoPreview = merged.logoFinal;
      this.faviconPreview = merged.faviconFinal;
      this.url = merged.url;
      this.status = merged.status;
      this.hasReady = true;
      this.activeTheme = merged.typeLayout;
      this.color = merged.color;
      this.javascript = merged.javascript;
      this.css = merged.css;
      this.facebook = merged.facebookPixelCode;
      this.gads = merged.googleAdsCode;
      this.ganalytic = merged.googleAnalyticsCode;
      this.tagManager = merged.tagManagerCode;
      this.rdrefreshToken = merged.rdrefreshToken;
      this.rdcode = merged.rdcode;
      this.rdSecret = merged.rdsecretClient;
      this.rdClient = merged.rdclienteId;
      this.descriptionAbout = merged.about;
    },
    async updateAdvanced() {
      this.hasReady = false;
      // Prioridade: os campos da página sobrescrevem os do finalWebsite (fw)
      const fw = this.finalWebsite || {};
      const payload = {
        "nome": this.name !== undefined ? this.name : (fw.nome !== undefined ? fw.nome : ''),
        "url": this.url !== undefined ? this.url : (fw.url !== undefined ? fw.url : ''),
        "url1": this.url1 !== undefined ? this.url1 : (fw.url1 !== undefined ? fw.url1 : null),
        "url2": this.url2 !== undefined ? this.url2 : (fw.url2 !== undefined ? fw.url2 : null),
        "title": this.title !== undefined ? this.title : (fw.title !== undefined ? fw.title : ''),
        "description": this.description !== undefined ? this.description : (fw.description !== undefined ? fw.description : ''),
        "keywords": this.keywords !== undefined ? this.keywords : (fw.keywords !== undefined ? fw.keywords : null),
        "logo": this.logo !== undefined ? this.logo : (fw.logo !== undefined ? fw.logo : ''),
        "color": this.color !== undefined ? this.color : (fw.color !== undefined ? fw.color : ''),
        "favicon": this.favicon !== undefined ? this.favicon : (fw.favicon !== undefined ? fw.favicon : ''),
        "logoFinal": this.logoPreview !== undefined ? this.logoPreview : (fw.logoFinal !== undefined ? fw.logoFinal : ''),
        "faviconFinal": this.faviconPreview !== undefined ? this.faviconPreview : (fw.faviconFinal !== undefined ? fw.faviconFinal : ''),
        "status": this.status !== undefined ? this.status : (fw.status !== undefined ? fw.status : null),
        "tagManagerCode": this.tagManager !== undefined ? this.tagManager : (fw.tagManagerCode !== undefined ? fw.tagManagerCode : ''),
        "typeLayout": this.activeTheme !== undefined ? this.activeTheme : (fw.typeLayout !== undefined ? fw.typeLayout : null),
        "javascript": this.javascript !== undefined ? this.javascript : (fw.javascript !== undefined ? fw.javascript : ''),
        "css": this.css !== undefined ? this.css : (fw.css !== undefined ? fw.css : null),
        "typeLayoutPortal": this.typeLayoutPortal !== undefined ? this.typeLayoutPortal : (fw.typeLayoutPortal !== undefined ? fw.typeLayoutPortal : null),
        "googleAnalyticsCode": this.ganalytic !== undefined ? this.ganalytic : (fw.googleAnalyticsCode !== undefined ? fw.googleAnalyticsCode : ''),
        "facebookPixelCode": this.facebook !== undefined ? this.facebook : (fw.facebookPixelCode !== undefined ? fw.facebookPixelCode : ''),
        "dateInsert": this.dateInsert !== undefined ? this.dateInsert : (fw.dateInsert !== undefined ? fw.dateInsert : ''),
        "email": this.email !== undefined ? this.email : (fw.email !== undefined ? fw.email : null),
        "phone": this.phone !== undefined ? this.phone : (fw.phone !== undefined ? fw.phone : null),
        "numberCollection": this.numberCollection !== undefined ? this.numberCollection : (fw.numberCollection !== undefined ? fw.numberCollection : null),
        "numberVideo": this.numberVideo !== undefined ? this.numberVideo : (fw.numberVideo !== undefined ? fw.numberVideo : null),
        "timeVideo": this.timeVideo !== undefined ? this.timeVideo : (fw.timeVideo !== undefined ? fw.timeVideo : null),
        "numberSubscription": this.numberSubscription !== undefined ? this.numberSubscription : (fw.numberSubscription !== undefined ? fw.numberSubscription : null),
        "about": this.descriptionAbout !== undefined ? this.descriptionAbout : (fw.about !== undefined ? fw.about : ''),
        "termUse": this.termUse !== undefined ? this.termUse : (fw.termUse !== undefined ? fw.termUse : null),
        "typeImageCoverCourse": this.typeImageCoverCourse !== undefined ? this.typeImageCoverCourse : (fw.typeImageCoverCourse !== undefined ? fw.typeImageCoverCourse : null),
        "visibleTitleCourse": this.visibleTitleCourse !== undefined ? this.visibleTitleCourse : (fw.visibleTitleCourse !== undefined ? fw.visibleTitleCourse : null),
        "googleAdsCode": this.gads !== undefined ? this.gads : (fw.googleAdsCode !== undefined ? fw.googleAdsCode : ''),
        "rdsecretClient": this.rdSecret !== undefined ? this.rdSecret : (fw.rdsecretClient !== undefined ? fw.rdsecretClient : ''),
        "rdclienteId": this.rdClient !== undefined ? this.rdClient : (fw.rdclienteId !== undefined ? fw.rdclienteId : ''),
        "rdcode": this.rdcode !== undefined ? this.rdcode : (fw.rdcode !== undefined ? fw.rdcode : ''),
        "rdrefreshToken": this.rdrefreshToken !== undefined ? this.rdrefreshToken : (fw.rdrefreshToken !== undefined ? fw.rdrefreshToken : '')
      }
      try {
        const response = await websiteApi.editWebsite(this.token, this.id, payload);
        this.getAdvanced();
        this.clearCache();
        this.hasReady = true;
        this.notify('Personalização atualizadas com sucesso!', 'success');
      } catch (error) {
        this.notify('Erro ao atualizar personalizações.', 'error');
        console.error('Erro ao atualizar dados do website:', error);
      }
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    async clearCache(){
      try {
        const response = await websiteApi.clearCache(this.token);
        this.messageStatusCache = true;
      } catch (error) {
        console.error('Erro ao limpar cache', error);
      }
    },
  },
  created(){
    this.getAdvanced();
  }   
}
</script>
<style scoped>
@media (max-width: 768px) {
  .weflix-admin-advancedLayout h3 {
    font-size: 20px;
    margin-bottom: 5px;
  }
  .weflix-admin-advancedLayout small {
    font-size: 12px;
    color: #666;
  }
  .weflix-admin-advancedLayout  .actionsSave {
    position: relative;
    top: 0;
    right: 0;
    padding: 10px;
  }
  .layoutLayout.advanced.weflix-admin-advancedLayout {
    padding: 16px
  }
  section.layoutLayout.advanced.weflix-admin-advancedLayout .col-form-inner.col-12.col-md-12.col-lg-12.flex {
    padding: 0;
  }
}
</style>
<style>
@import url('./css/advanced.css');
span.text-danger.js-warning , span.text-danger.css-warning {
  font-size: 11px;
}
</style>